const Header = ({switchSection, hideOverlay}) => {
    return (
        <div className="row">
            <div className="col-auto underline-btn show-btn pb-15 sm-me-0 text-center align-center content-center gap-8 active" onClick={() => switchSection(0)}>
                <span className="curtains-icon curtains-icon-Property-1Off size-24"></span>
                <span>My Wishlist</span>
            </div>
            <div className="col-auto underline-btn show-btn pb-15 sm-me-0 text-center align-center content-center" onClick={() => switchSection(1)}>
                <span>Recently Viewed</span>
            </div>
            <div className="col content-end sm-pt-4"><span className="curtains-icon curtains-icon-close size-24 pointer" onClick={hideOverlay}></span></div>
        </div>
    )
}

export default Header